import 'dayjs/locale/pt-br'
import { Dayjs } from 'dayjs'

const pt_br = {
  calendar: {
    sameDay: '[Hoje às] LT',
    nextDay: '[Amanhã às] LT',
    nextWeek: 'dddd [às] LT',
    lastDay: '[Ontem às] LT',
    lastWeek: function (now: Dayjs) {
      return now.day() === 0 || now.day() === 6
        ? now.format('[Último] dddd [às] LT') // Saturday + Sunday
        : now.format('[Última] dddd [às] LT') // Monday - Friday
    },
    sameElse: 'L'
  }
}

export default pt_br
